import NavigateLocation from "@/components/shared/leaflet/navigateLocation";
import Paragraph from "@/components/shared/text/paragraph";
import { useTranslations } from "@/i18n/utils";
import type { Venue } from "@/types/artist";
import React, { Suspense } from "react";

const LazyLeafletMap = React.lazy(
  () => import("@/components/shared/leaflet/Map"),
);

const EventSlugLocation = ({
  venue,
  lang,
}: {
  venue: Venue;
  lang: "es" | "en";
}) => {
  const translate = useTranslations(lang);

  return (
    <Suspense fallback={<div className="h-[293px]"></div>}>
      <div className="mt-6 md:hidden">
        <Paragraph size="md" className="text-white-80">
          {translate("publicProfile.events.details.location.title")}
        </Paragraph>
      </div>
      <NavigateLocation lat={venue.lat} long={venue.long}>
        <div className="mt-4 h-[293px] cursor-pointer md:mt-10">
          <LazyLeafletMap
            lat={venue.lat}
            long={venue.long}
            name={venue.name}
            address={venue.city}
          />
        </div>
      </NavigateLocation>
    </Suspense>
  );
};

export default EventSlugLocation;
